import { AfterViewInit, Component, OnInit } from '@angular/core';
import BigNumber from 'bignumber.js';
import { forkJoin } from 'rxjs';
import { ShoppingCartService } from 'src/app/shared/services/cart/shopping-cart.service';
import { TokensService } from 'src/app/shared/services/tokens/token.service';

@Component({
    selector: 'app-token-information',
    templateUrl: './token-information.component.html',
    styleUrls: ['./token-information.component.scss']
})
export class TokenInformationComponent implements OnInit, AfterViewInit {

    public loading: boolean;
    public quoteDay: BigNumber;
    public tokens: BigNumber = new BigNumber(0);
    public money: BigNumber = new BigNumber(0);
    public tokenName: string;
    public mainToken: string;
    public tokenIcon: string = ''; // image URL

    constructor(
        private readonly shoppingCartService: ShoppingCartService,
        private readonly tokenService: TokensService,
    ) { }

    public ngOnInit(): void {
        this.tokenService.getTokens().subscribe(tokens => {
            let mainToken = tokens.find(tkn => tkn.isMain);
            this.mainToken = mainToken.id;
            this.getUserBalance(mainToken.id);
        });
    }

    public getUserBalance(unitOfMoney: string): void {
        forkJoin([
            this.shoppingCartService.quotations(unitOfMoney),
            this.shoppingCartService.balance(unitOfMoney)
        ]).subscribe(async ([data, balance]) => {
            this.quoteDay = new BigNumber(data.amount || 0);
            this.tokens = new BigNumber(balance[0]?.balance);
            this.money = new BigNumber(this.tokens).multipliedBy(this.quoteDay);
        });
    }

    public ngAfterViewInit(): void {
        this.getCardWidth();
        window.addEventListener('resize', () => {
            this.getCardWidth();
        });
    }

    public getCardWidth(): void {
        // let tokenCard = document.querySelector('.token-card') as HTMLElement;
        // let tokenCardWidth = document.querySelector('.token-card').clientWidth;

        // if (tokenCardWidth < 330) {
        //     tokenCard.classList.replace('inline', 'column');
        // } else {
        //     tokenCard.classList.replace('column', 'inline');
        // }
        // console.log(tokenCard);
    }

    public toNumber(bigNumber: BigNumber): number {
        return bigNumber?.toNumber();
    }
}
